import { GENERAL_ERROR, buildErrorsFromResponse } from '../../../core/js/utils/errorHandling';
import { setPriceForQuantity } from '@product/js/utils/cartUtils';

export const ADD_TO_CART = 'ADD_TO_CART';
export const ADD_TO_CART_ERROR = 'ADD_TO_CART_ERROR';
export const ADD_TO_WISHLIST = 'ADD_TO_WISHLIST';
export const MOVE_TO_WISHLIST = 'MOVE_TO_WISHLIST';
export const MOVED_TO_WISHLIST = 'MOVED_TO_WISHLIST';
export const LIST_ITEM_UPDATED = 'LIST_ITEM_UPDATED';
export const ADD_TO_WISHLIST_RESOLUTION = 'ADD_TO_WISHLIST_RESOLUTION';
export const MOVE_TO_WISHLIST_RESOLUTION = 'MOVE_TO_WISHLIST_RESOLUTION';
export const ADD_WISHLIST_TO_UI = 'ADD_WISHLIST_TO_UI';
export const ADDED_TO_CART = 'ADDED_TO_CART';
export const CAN_ADD_TO_LIST = 'CAN_ADD_TO_LIST';
export const CANCEL_HIDE_CART_CONFIRM_TIMER = 'CANCEL_HIDE_CART_CONFIRM_TIMER';
export const CHANGE_COLOR = 'CHANGE_COLOR';
export const CHANGE_QUANTITY = 'CHANGE_QUANTITY';
export const CHANGE_SIZE_TYPE = 'CHANGE_SIZE_TYPE';
export const CHANGE_SIZE = 'CHANGE_SIZE';
export const CHECK_WISHLISTS = 'CHECK_WISHLISTS';
export const CREATE_WISHLIST_UI = 'CREATE_WISHLIST_UI';
export const DELETE_UPLOADED_PHOTO = 'DELETE_UPLOADED_PHOTO';
export const EXPAND_IMAGE = 'EXPAND_IMAGE';
export const HIDE_CART_CONFIRM = 'HIDE_CART_CONFIRM';
export const RECEIVE_REVIEWS = 'RECEIVE_REVIEWS';
export const RECEIVE_WRITE_REVIEW_ERRORS = 'RECEIVE_WRITE_REVIEW_ERRORS';
export const RECEIVE_WRITE_REVIEW_FIELDS = 'RECEIVE_WRITE_REVIEW_FIELDS';
export const RECEIVE_WRITE_REVIEW_IMAGE_UPLOAD_ERRORS = 'RECEIVE_WRITE_REVIEW_IMAGE_UPLOAD_ERRORS';
export const WRITE_REVIEW_AUTOFILL = 'WRITE_REVIEW_AUTOFILL';
export const RECEIVE_UGC = 'RECEIVE_UGC';
export const REMOVE_PRODUCT = 'REMOVE_PRODUCT';
export const RESET_ADD_TO_CART = 'RESET_ADD_TO_CART';
export const RESET_HIDE_CART_CONFIRM_TIMER = 'RESET_HIDE_CART_CONFIRM_TIMER';
export const RESET_PHOTO_UPLOAD_PREVIEW = 'RESET_PHOTO_UPLOAD_PREVIEW';
export const RESET_QUANTITY = 'RESET_QUANTITY';
export const RESET_SELECTED_SKU = 'RESET_SELECTED_SKU';
export const RESET_SIZE = 'RESET_SIZE';
export const SAVE_FORM_VALIDATION = 'SAVE_FORM_VALIDATION';
export const SAVE_PHOTO_UPLOAD_PREVIEW = 'SAVE_PHOTO_UPLOAD_PREVIEW';
export const SAVE_BOPIS_POOLS = 'SAVE_BOPIS_POOLS';
export const SAVE_PRODUCT = 'SAVE_PRODUCT';
export const SAVE_PRODUCT_ERROR = 'SAVE_PRODUCT_ERROR';
export const SAVE_REQUEST_SWATCH_SELECTIONS = 'SAVE_REQUEST_SWATCH_SELECTIONS';
export const SAVE_REQUEST_SWATCH_SELECTION_ERROR = 'SAVE_REQUEST_SWATCH_SELECTION_ERROR';
export const SAVE_WRITE_REVIEW_FORM_DATA = 'SAVE_WRITE_REVIEW_FORM_DATA';
export const SAVE_WRITE_REVIEW_VALIDATION = 'SAVE_WRITE_REVIEW_VALIDATION';
export const SET_FREE_SHIPPING_FLAG = 'SET_FREE_SHIPPING_FLAG';
export const SELECT_COLOR_SWATCH = 'SELECT_COLOR_SWATCH';
export const SET_REVIEW_PAGE = 'SET_REVIEW_PAGE';
export const SHOW_PHOTO_UPLOAD = 'SHOW_PHOTO_UPLOAD';
export const SHOW_SHIP_TO_STORE_ERROR = 'SHOW_SHIP_TO_STORE_ERROR';
export const SUBMIT_PHOTO_UPLOAD = 'SUBMIT_PHOTO_UPLOAD';
export const SUBMIT_WRITE_REVIEW = 'SUBMIT_WRITE_REVIEW';
export const TOGGLE_NO_STORE_MESSAGE = 'TOGGLE_NO_STORE_MESSAGE';
export const UPDATE_PRODUCT_META = 'UPDATE_PRODUCT_META';
export const UPDATE_REVIEW_PAGES = 'UPDATE_REVIEW_PAGES';
export const UPDATE_SELECTED_SKU = 'UPDATE_SELECTED_SKU';
export const UPDATE_TOTAL_STOCK = 'UPDATE_TOTAL_STOCK';
export const UPDATE_WISHLIST_UI = 'UPDATE_WISHLIST_UI';
export const UPDATE_BOPIS_STOCK_INFO = 'UPDATE_BOPIS_STOCK_INFO';
export const WRITE_REVIEW_SUCCESS = 'WRITE_REVIEW_SUCCESS';
export const WRITE_REVIEW_IMAGE_UPLOAD_SUCCESS = 'WRITE_REVIEW_IMAGE_UPLOAD_SUCCESS';
export const RECEIVE_WRITE_REVIEW_FIELDS_ERRORS = 'RECEIVE_WRITE_REVIEW_FIELDS_ERRORS';
export const SHOW_PRODUCT_ACTION_ERROR = 'SHOW_PRODUCT_ACTION_ERROR';
export const HIDE_PRODUCT_ACTION_ERROR = 'HIDE_PRODUCT_ACTION_ERROR';
export const SHOW_CANNOT_ADD_TO_LIST_ERROR = 'SHOW_CANNOT_ADD_TO_LIST_ERROR';
export const HIDE_CANNOT_ADD_TO_LIST_ERROR = 'HIDE_CANNOT_ADD_TO_LIST_ERROR';
export const RESET_WRITE_REVIEW_FORM = 'RESET_WRITE_REVIEW_FORM';
export const UPDATE_CART_ITEM = 'UPDATE_CART_ITEM';
export const SAVE_FORM_VALIDATION_EGIFTCARD = 'SAVE_FORM_VALIDATION_EGIFTCARD';
export const RESET_ADD_TO_WISHLIST = 'RESET_ADD_TO_WISHLIST';
export const SAVE_REQUEST_SWATCH_FORM_DATA = 'SAVE_REQUEST_SWATCH_FORM_DATA';
export const RESET_REQUEST_SWATCH_FORM_DATA = 'RESET_REQUEST_SWATCH_FORM_DATA';
export const RESET_REQUEST_SWATCH_SELECTIONS = 'RESET_REQUEST_SWATCH_SELECTIONS';
export const SET_SELECTED_PRODUCT_FOR_REQUEST_SWATCH = 'SET_SELECTED_PRODUCT_FOR_REQUEST_SWATCH';
export const BACK_IN_STOCK_VIEW = 'BACK_IN_STOCK_VIEW';
export const BACK_IN_STOCK_NOTIFICATION_FAILURE = 'BACK_IN_STOCK_NOTIFICATION_FAILURE';
export const ADD_TO_CART_READY = 'ADD_TO_CART_READY';
export const RESET_WISHLISTS = 'RESET_WISHLISTS';
export const SET_TILE_TYPE_OVERRIDE = 'SET_TILE_TYPE_OVERRIDE';
export const SET_REQUEST_SWATCH_COUNTRIES = 'SET_REQUEST_SWATCH_COUNTRIES';
export const SET_MARKETPLACE_EMAIL_AUTOFILL = 'SET_MARKETPLACE_EMAIL_AUTOFILL';

export function addToCart(e, component) {
    return {
        type: ADD_TO_CART,
        payload: {},
        meta: {
            component: component,
            event: e
        }
    };
}

export function addToCartError(errorCode, component) {
    return {
        type: ADD_TO_CART_ERROR,
        meta: {
            component: component
        },
        payload: {
            code: errorCode
        }
    };
}

export function addedToCart(confirmOptions, component) {
    const options = setPriceForQuantity(confirmOptions);

    return {
        type: ADDED_TO_CART,
        meta: {
            component: component
        },
        payload: options || {}
    };
}

export function addToWishlist(params, event, component) {
    return {
        type: ADD_TO_WISHLIST,
        meta: {
            event: event,
            component: component
        },
        payload: params
    };
}

export function addToWishListResolution(messages, component) {
    return {
        type: ADD_TO_WISHLIST_RESOLUTION,
        meta: {
            component: component
        },
        payload: {
            success: messages.success,
            successParams: messages.successParams,
            error: messages.error
        }
    };
}

export function addWishlistsToUI(wishlists, component) {
    return {
        type: ADD_WISHLIST_TO_UI,
        meta: {
            component: component
        },
        payload: wishlists
    };
}

export function canAddToList(addToList, component) {
    return {
        type: CAN_ADD_TO_LIST,
        meta: {
            component: component
        },
        payload: {
            canAddToList: addToList
        }
    };
}

export function createWishlistUI(wishlists, component) {
    return {
        type: CREATE_WISHLIST_UI,
        meta: {
            component: component
        },
        payload: wishlists
    };
}

export function checkWishlists(params, event, component) {
    return {
        type: CHECK_WISHLISTS,
        meta: {
            event: event,
            component: component
        },
        payload: {}
    };
}

export function cancelHideCartConfirmTimer() {
    return {
        type: CANCEL_HIDE_CART_CONFIRM_TIMER,
        meta: {
        },
        payload: {
            isConfirmTimerActive: false
        }
    };
}

export function changeColor(colorName, imageId, selectedSwatch, component) {
    return {
        type: CHANGE_COLOR,
        meta: {
            component: component
        },
        payload: {
            productImageViewer: {
                colorCode: selectedSwatch.colorCode
            },
            productAddToCart: {
                imageId: imageId
            },
            productDetails: {
                colorCode: selectedSwatch.colorCode
            }
        }
    };
}

export function changeQuantity(quantity, event, component) {
    return {
        type: CHANGE_QUANTITY,
        meta: {
            event: event,
            component: component
        },
        payload: {
            productBopis: {
                quantity: quantity
            },
            productControls: {
                quantity: quantity
            },
            productMessages: {
                error: null
            }
        }
    };
}

export function changeSize(sizeName, event, component) {
    return {
        type: CHANGE_SIZE,
        meta: {
            event: event,
            component: component
        },
        payload: {
            sizeName: sizeName
        }
    };
}

export function changeSizeType(sizeTypeCode, event, component) {
    return {
        type: CHANGE_SIZE_TYPE,
        meta: {
            event: event,
            component: component
        },
        payload: {
            sizeTypeCode: sizeTypeCode
        }
    };
}

export function deleteUploadedPhoto(loopIndex) {
    return {
        type: DELETE_UPLOADED_PHOTO,
        meta: {
        },
        payload: {
            loopIndex: loopIndex
        }
    };
}

export function expandImage(src, caption, e, component) {
    return {
        type: EXPAND_IMAGE,
        payload: {
            src: src,
            caption: caption
        },
        meta: {
            event: e,
            component: component
        }
    };
}

/**
 * Return action object for hiding product action errors
 * Note: No payload
 * @param {object}  component       Component object that is dispatching action
 * @returns {object}                Object for reducer to parse into store.
 */
export function hideProductActionError(component) {
    return {
        type: HIDE_PRODUCT_ACTION_ERROR,
        meta: {
            component: component
        }
    };
}

export function hideCannotAddToListError(component) {
    return {
        type: HIDE_CANNOT_ADD_TO_LIST_ERROR,
        meta: {
            component: component
        }
    };
}

export function hideCartConfirm() {
    return {
        type: HIDE_CART_CONFIRM,
        meta: {
        },
        payload: {
            showConfirm: false,
            confirmViewModel: {}
        }
    };
}

export function moveToWishlist(params, event, component, store) {
    return {
        type: MOVE_TO_WISHLIST,
        meta: {
            event: event,
            component: component,
            store: store
        },
        payload: params
    };
}

export function moveToWishListResolution(messages, component) {
    return {
        type: MOVE_TO_WISHLIST_RESOLUTION,
        meta: {
            component: component
        },
        payload: {
            success: messages.success,
            successParams: messages.successParams,
            error: messages.error
        }
    };
}

export function movedToWishList(component) {
    return {
        type: MOVED_TO_WISHLIST,
        meta: {
            component: component
        },
        payload: {}
    };
}

/**
 * This is fired when a wishlist/registry list item is updated
 * @param payload
 */
export function listItemUpdated(payload) {
    return {
        type: LIST_ITEM_UPDATED,
        payload: payload
    };
}

export function receiveReviews(response) {
    return {
        type: RECEIVE_REVIEWS,
        meta: {
        },
        payload: {
            productReviews: response
        }
    };
}

export function receiveUgc(response) {
    return {
        type: RECEIVE_UGC,
        meta: {
        },
        payload: {
            ugc: response
        }
    };
}

export function receiveWriteReviewErrors(response) {
    return {
        type: RECEIVE_WRITE_REVIEW_ERRORS,
        meta: {
        },
        error: true,
        payload: {
            errors: response
        }
    };
}

export function receiveWriteReviewFields(response) {
    return {
        type: RECEIVE_WRITE_REVIEW_FIELDS,
        meta: {
        },
        payload: {
            fields: response
        }
    };
}

export function receiveWriteReviewImageUploadErrors(response) {
    return {
        type: RECEIVE_WRITE_REVIEW_IMAGE_UPLOAD_ERRORS,
        meta: {
        },
        error: true,
        payload: {
            errors: response
        }
    };
}

export function removeProduct() {
    return {
        type: REMOVE_PRODUCT,
        meta: {
        },
        payload: {}
    };
}

export function resetAddToCart(component) {
    return {
        type: RESET_ADD_TO_CART,
        meta: {
            component: component
        },
        payload: {}
    };
}

export function resetHideCartConfirmTimer() {
    return {
        type: RESET_HIDE_CART_CONFIRM_TIMER,
        meta: {
        },
        payload: {
            isConfirmTimerActive: true
        }
    };
}

export function resetPhotoUploadPreview() {
    return {
        type: RESET_PHOTO_UPLOAD_PREVIEW,
        meta: {
        }
    };
}

export function resetQuantity(quantity, component) {
    return {
        type: RESET_QUANTITY,
        meta: {
            component: component
        },
        payload: {
            quantity: quantity
        }
    };
}

export function resetSelectedSku(event, component) {
    return {
        type: RESET_SELECTED_SKU,
        meta: {
            event: event,
            component: component
        },
        payload: {}
    }
}

export function resetSize(sizeId, sizeName, component) {
    return {
        type: RESET_SIZE,
        meta: {
            component: component
        },
        payload: {
            sizeId: sizeId,
            sizeName: sizeName
        }
    };
}

export function saveFormValidation(values, messages, dateFormats = {}, component) {
    return {
        type: SAVE_FORM_VALIDATION,
        meta: {
            component: component
        },
        payload: {
            productControls: {
                validation: {
                    values: values,
                    messages: messages,
                    dateFormats: dateFormats
                }
            }
        }
    };
}

export function savePhotoUploadPreview(file, fileName, url) {
    return {
        type: SAVE_PHOTO_UPLOAD_PREVIEW,
        meta: {
        },
        payload: {
            file: file,
            fileName: fileName,
            url: url
        }
    };
}

export function saveBopisPools(res) {
    return {
        type: SAVE_BOPIS_POOLS,
        meta: {
        },
        payload: {
            productBopis: {
                selectedSku: res.product.selectedSku,
                stock: res.product.stock
            },
            selectedSku: res.product.selectedSku,
            skuInfo: res.product.skuInfo
        }
    };
}

export function saveProduct(res) {
    return {
        type: SAVE_PRODUCT,
        meta: {
        },
        payload: {
            product: res.product
        }
    };
}
export function saveProductError(e) {
    return {
        type: SAVE_PRODUCT_ERROR,
        meta: {
        },
        error: e
    };
}

export function saveRequestSwatchSelectionError(message, selectionError = true) {
    return {
        type: SAVE_REQUEST_SWATCH_SELECTION_ERROR,
        meta: {
        },
        payload: {
            selectionError: selectionError,
            message: message
        }
    };
}

export function saveRequestSwatchSelections(selectedSwatches, selectedCount, swatchesString, userInitiatedSelection = false, selectionError = false) {
    return {
        type: SAVE_REQUEST_SWATCH_SELECTIONS,
        meta: {
        },
        payload: {
            selectedSwatches: selectedSwatches,
            selectedCount: selectedCount,
            swatchesString: swatchesString,
            userInitiatedSelection: userInitiatedSelection,
            selectionError: selectionError
        }
    };
}

export function saveWriteReviewFormData(formData) {
    return {
        type: SAVE_WRITE_REVIEW_FORM_DATA,
        meta: {
        },
        payload: {
            formData: formData
        }
    };
}

export function saveWriteReviewValidation(values, msgs) {
    return {
        type: SAVE_WRITE_REVIEW_VALIDATION,
        meta: {
        },
        payload: {
            values: values,
            msgs: msgs
        }
    };
}

export function selectColorSwatch(colorCode, event, component) {
    return {
        type: SELECT_COLOR_SWATCH,
        meta: {
            event: event,
            component: component
        },
        payload: {
            colorCode: colorCode
        }
    };
}

export function setFreeShippingFlag(qualifiedForFreeShipping) {
    return {
        type: SET_FREE_SHIPPING_FLAG,
        meta: {
        },
        payload: {
            qualifiedForFreeShipping: qualifiedForFreeShipping
        }
    };
}

export function setReviewPage(page) {
    return {
        type: SET_REVIEW_PAGE,
        meta: {
        },
        payload: {
            reviewPage: page
        }
    };
}

/**
 * Return action object with for showing product action errors
 * Error in payload based on egift card or not
 * @param {object}  component           Component object that is dispatching action
 * @param {string}  errorDescription    Specific to the actual input being clicked to dispatch action
 * @param {boolean} isEgiftCard         True if product is e-gift card
 * @returns {object}                    Object for reducer to parse into store.
 */
export function showProductActionError(component, errorDescription, isEgiftCard) {
    return {
        type: SHOW_PRODUCT_ACTION_ERROR,
        meta: {
            component: component
        },
        payload: {
            error: isEgiftCard ? 'ERROR_PRODUCT_FORM_ADD_OR_UPDATE' : `ERROR_PRODUCT_SLICE_${errorDescription}`
        }
    };
}

export function showCannotAddToListError(component, error = null) {
    return {
        type: SHOW_CANNOT_ADD_TO_LIST_ERROR,
        meta: {
            component: component
        },
        payload: {
            error: error
        }
    };
}

export function showPhotoUpload() {
    return {
        type: SHOW_PHOTO_UPLOAD,
        meta: {
        }
    };
}

export function showShipToStoreError(e, component) {
    return {
        type: SHOW_SHIP_TO_STORE_ERROR,
        meta: {
            event: e,
            component: component
        }
    };
}

export function writeReviewAutofill(results) {
    return {
        type: WRITE_REVIEW_AUTOFILL,
        payload: results
    };
}

export function submitPhotoUpload(data, caption, loaderId) {
    return {
        type: SUBMIT_PHOTO_UPLOAD,
        meta: {
        },
        payload: {
            data: data,
            caption: caption,
            loaderId: loaderId
        }
    };
}

export function submitWriteReview(queryString) {
    return {
        type: SUBMIT_WRITE_REVIEW,
        meta: {
        },
        payload: {
            queryString: queryString
        }
    };
}

export function toggleNoStoreMessage(bool, meta = {}) {
    return {
        type: TOGGLE_NO_STORE_MESSAGE,
        meta: meta,
        payload: {
            productBopis: {
                noStoreMessage: bool
            }
        }
    };
}

export function updateProductMeta(data, component) {
    return {
        type: UPDATE_PRODUCT_META,
        meta: {
            component: component
        },
        payload: {
            productMeta: data
        }
    };
}

export function updateReviewPages(total, next, prev) {
    return {
        type: UPDATE_REVIEW_PAGES,
        meta: {
        },
        payload: {
            totalPages: total,
            nextPage: next,
            prevPage: prev
        }
    };
}

export function updateSelectedSku(
    sku,
    sizeTypeCode,
    sizeId,
    sizeName,
    colorCode,
    colorName,
    totalStock,
    price,
    messages = {},
    bopisAvailabilityMessages = [],
    bopisStock = {},
    availabilityInfo = {},
    component = null,
    hasVideo = false,
    backInStockEligible = false,
    hideListAddLinks = false
) {
    const selectedSku = {
        availabilityInfo: availabilityInfo,
        sku: sku
    };
    const shipRestriction = sku ? sku.shipRestriction : null;
    const isFlatRate = sku ? sku.isFlatRate : null;

    return {
        type: UPDATE_SELECTED_SKU,
        meta: {
            component: component
        },
        payload: {
            productControls: {
                sizeId: sizeId,
                sizeName: sizeName,
                sizeTypeCode: sizeTypeCode,
                colorCode: colorCode,
                colorName: colorName,
                totalStock: totalStock,
                backInStockEligible: backInStockEligible
            },
            productBopis: {
                availabilityMessages: bopisAvailabilityMessages,
                selectedSku: selectedSku,
                showShipToStoreError: false,
                stock: bopisStock,
                flatRateCode: messages.flatRateCode
            },
            productDetails: {
                shipRestriction: shipRestriction,
                isFlatRate: isFlatRate
            },
            productMessages: {
                error: messages.error,
                success: messages.success,
                successParams: messages.successParams
            },
            productMeta: {
                hasVideo: hasVideo,
                price: price
            },
            selectedSku: selectedSku,
            hideListAddLinks: hideListAddLinks
        }
    };
}

export function updateTotalStock(totalStock, component) {
    return {
        type: UPDATE_TOTAL_STOCK,
        meta: {
            component: component
        },
        payload: {
            totalStock: totalStock
        }
    };
}

export function updateWishlistUI(wishlists, component) {
    return {
        type: UPDATE_WISHLIST_UI,
        meta: {
            component: component
        },
        payload: wishlists
    };
}

export function updateBopisStockInfo(stockInfo) {
    return {
        type: UPDATE_BOPIS_STOCK_INFO,
        meta: {
        },
        payload: {
            productBopis: {
                stock: stockInfo
            }
        }
    };
}

export function writeReviewImageUploadSuccess(urls, captions) {
    return {
        type: WRITE_REVIEW_IMAGE_UPLOAD_SUCCESS,
        meta: {
        },
        payload: {
            urls: urls,
            captions: captions
        }
    };
}

export function writeReviewSuccess() {
    return {
        type: WRITE_REVIEW_SUCCESS,
        meta: {
        }
    };
}

export function receiveWriteReviewFieldsErrors(response) {
    return {
        type: RECEIVE_WRITE_REVIEW_FIELDS_ERRORS,
        meta: {
        },
        error: true,
        payload: {
            errors: response
        }
    };
}

export function resetWriteReviewForm() {
    return {
        type: RESET_WRITE_REVIEW_FORM,
        meta: {
        }
    };
}

export function updateCartItem(elem) {
    return {
        type: UPDATE_CART_ITEM,
        payload: {
            element: elem
        },
        meta: {
        }
    };
}

export function resetAddToWishlist(component) {
    return {
        type: RESET_ADD_TO_WISHLIST,
        meta: {
            component: component
        },
        payload: {}
    };
}

export function saveRequestSwatchFormData(formData) {
    return {
        type: SAVE_REQUEST_SWATCH_FORM_DATA,
        payload: {
            formData: formData
        }
    };
}

export function resetRequestSwatchSelections() {
    return {
        type: RESET_REQUEST_SWATCH_SELECTIONS,
        payload: {}
    };
}

export function resetRequestSwatchFormData() {
    return {
        type: RESET_REQUEST_SWATCH_FORM_DATA,
        payload: {}
    };
}

export function setSelectedProductForRequestSwatch(product, selectedColorCode) {
    return {
        type: SET_SELECTED_PRODUCT_FOR_REQUEST_SWATCH,
        payload: {
            product: product,
            selectedColorCode: selectedColorCode
        }
    };
}

export function setRequestSwatchCountries(countries) {
    return {
        type: SET_REQUEST_SWATCH_COUNTRIES,
        payload: {
            countries: countries,
        }
    };
}

export function backInStockView(viewType, event, component) {
    return {
        type: BACK_IN_STOCK_VIEW,
        meta: {
            event: event,
            component: component
        },
        payload: {
            backInStockView: viewType
        }
    };
}

export function backInStockNotificationFailure(response) {
    const payload = buildErrorsFromResponse(response);

    return {
        type: BACK_IN_STOCK_NOTIFICATION_FAILURE,
        error: true,
        payload: payload
    };
}

export function addToCartReady(component) {
    return {
        type: ADD_TO_CART_READY,
        meta: {
            component: component
        },
        payload: {}
    };
}

export function resetWishlists() {
    return {
        type: RESET_WISHLISTS
    };
}

// TODO: UW-14895 - remove when SS_PDPTILETYPE test is over
export function setTileTypeOverride(tileTypeOverride) {
    return {
        type: SET_TILE_TYPE_OVERRIDE,
        payload: {
            tileTypeOverride: tileTypeOverride
        }
    };
}

export function setMarketplaceEmailAutofill(emailAddress) {
    return {
        type: SET_MARKETPLACE_EMAIL_AUTOFILL,
        payload: emailAddress,
    };
}
